import data from '@emoji-mart/data';
import Picker from '@emoji-mart/react';
import { Component } from 'react';
import { IconContext } from 'react-icons';
import { FaSmile } from 'react-icons/fa';
import emojiMarti18n from '../i18n/emoji-mart';
import languageService from '../services/languageService';

class ChatEmojiPicker extends Component<
  { show: boolean; onEmojiClick: (emoji: { native: string }) => void },
  { show: boolean }
> {
  private wrapperRef: any;

  constructor(props: {
    show: boolean;
    onEmojiClick: (emoji: { native: string }) => void;
  }) {
    super(props);
    this.state = {
      show: props.show,
    };
  }

  public componentDidMount() {
    document.addEventListener('mousedown', this.handleClickOutside);
  }

  public toggle = () => {
    const { show } = this.state;
    this.setState({
      show: !show,
    });
  };

  public hide = () => {
    this.setState({
      show: false,
    });
  };

  public handleClickOutside = (event) => {
    if (this.wrapperRef && !this.wrapperRef.contains(event.target)) {
      this.hide();
    }
  };

  public setWrapperRef = (node) => {
    this.wrapperRef = node;
  };

  public render() {
    const { onEmojiClick } = this.props;
    const { show } = this.state;
    const language = languageService.get();

    return (
      <div ref={this.setWrapperRef}>
        <div className='emoji-button' aria-hidden='true' onClick={this.toggle}>
          <IconContext.Provider value={{ color: 'grey' }}>
            <FaSmile />
          </IconContext.Provider>
        </div>
        {show && (
          <div>
            <Picker
              data={data}
              dynamicWidth={true}
              navPosition={'bottom'}
              previewPosition={'none'}
              onEmojiSelect={onEmojiClick}
              showSkinTones={false}
              showPreview={false}
              i18n={this.getI18NForLanguage(emojiMarti18n, language)}
            />
          </div>
        )}
      </div>
    );
  }

  private getI18NForLanguage = (
    i18nEmojiMart: Record<string, unknown>,
    language = '',
  ) => {
    return i18nEmojiMart?.[language] || i18nEmojiMart.en;
  };
}

export default ChatEmojiPicker;
